import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {Dictionary} from "../../../../types/rendering";
export default class Mutators
{
	_settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;

    constructor(settings: DefaultSettings)
    {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    getMutator(){
        const settings = this._settings;
        return (parameters: Dictionary): Dictionary => {
            let inputBoxClassName = settings.classNames.inputboxTextAreaClassName;
            let inputBox = document.getElementsByClassName(inputBoxClassName)[0];
            
            if(document.activeElement === inputBox && !settings.inputBox.keepPlaceholder) {
                (parameters.attributes as Dictionary)['placeholder'] = "";
            }
            
            return parameters
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-inputbox/src/renderers/mutator.ts